import Feature3 from './Feature3'
export default Feature3
